// extracted by mini-css-extract-plugin
module.exports = {"input":"NewMessageModal_input__2Ozis"};